<template>
<div class="pageHeader" :style="{ 'height': this.subtitle1 && this.subtitle2 && this.small ? '277px' : !this.subtitle1 && !this.subtitle2 && this.small ? '150px':'504px ' }">
       <!--  <div class="imagePlaceholder">
            <img v-if="imageBackGround == true && bannerImageName" class="banner-pasteImageIcon" alt="" v-bind:src="'/api/image/get/'+bannerImageName" />
        </div> -->

        <!-- Banner image should be displayed only for New&Actu page -->
        <div v-if="search" class="imagePlaceholder">
            <img class="banner-pasteImageIcon" alt="" src="@/assets/images/news-banner.png" />
        </div>
        <div class="content1">
            <div class="text">
                <div class="text1">
                    <h1 class="pageTitle pt-4">{{ this.pageTitle }}</h1>
                    <div class="atVeroEosContainer">
                        <p class="subtitle">{{this.subtitle1}} </p>
                        <p class="subtitle" v-if="search===false">{{this.subtitle2}}</p>
                        <div v-else  class="mt-3 input-group">

                            <div class="row form-control h-100" style="background-color: white; border-radius: 8px !important; border-color: transparent !important;">
                                <div class="col-sm-12" style="display: flex;">
                                    <div class="col-11 text-left">
                                        <b-input type="text" v-model="searchInput" 
                                        @keyup.native.enter="refresh()"
                                        class="form-control font-size-16 text-muted" 
                                        placeholder="Recherche" 
                                        style=" border-color: transparent !important;"/>
                                    </div>
                                    <div class="col-1 d-flex align-items-center justify-content-center" @click="refresh()">
                                        <img src="@/assets/images/search.png" width="24px" height="24px" style="cursor: pointer;" >
                                    </div>
                                </div>
                            </div>     
                    </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default ({

    data() {
        return{
            searchInput:""
        }
    },

    props: {
        bannerImageName:{
          type:String,
          default:null
      },
        pageTitle:{
          type:String,
          default:null
      },
      subtitle1:{
          type:String,
          default:null
      },
      subtitle2:{
          type:String,
          default:null
      },
      search:{
          type:Boolean,
          default:false
      },
      imageBackGround:{
          type:Boolean,
          default:true
      },
      small:{
          type:Boolean,
          default:true
      }
    },

    methods: {
        refresh(){
            this.$emit("refresh", this.searchInput);

        }

    },


    name: "Banner",
});
</script>
<style scoped>
/* Desktop styles */
@media (min-width: 768px) {
    .banner-pasteImageIcon {
        position: absolute;
        height: 100%;
        width: 100%;
        top: 0%;
        right: 0%;
        bottom: 0%;
        left: 0%;
        max-width: 100%;
        overflow: hidden;
        max-height: 100%;
        object-fit: cover;
        padding: 2%;
        padding-bottom: 0%;
    }

    .imagePlaceholder {
        position: absolute;
        height: 100%;
        width: 100%;
        top: 0%;
        right: 0%;
        bottom: 0%;
        left: 0%;
        overflow: hidden;
    }

    .pageTitle {
        align-self: stretch;
        position: relative;
        letter-spacing: -1px;
        line-height: 58px;
        font-weight: 600;
        font-size: inherit;
        margin: 0;
        color: #000;
    }

    .subtitle {
        margin: 0;
    }

    .atVeroEosContainer {
        align-self: stretch;
        position: relative;
        font-size: 18px;
        line-height: 30px;
        color: #3e3e59;
    }

    .text1 {
        align-self: stretch;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;
        gap: 12px;
    }

    .text {
        width: 600px;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: center;
    }

    .content1 {
        position: absolute;
        top: calc(50% - 65px);
        left: calc(50% - 299.5px);
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }

    .pageHeader {
        position: relative;
        background-color: #fff;
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 52px;
        box-sizing: border-box;
        text-align: center;
        font-size: 54px;
        color: #121212;
        font-family: Poppins;
    }
}

/* Mobile styles */
@media (max-width: 767px) {
    .banner-pasteImageIcon {
        position: absolute;
        height: 100%;
        width: 100%;
        top: 0%;
        right: 0%;
        bottom: 0%;
        left: 0%;
        max-width: 100%;
        overflow: hidden;
        max-height: 100%;
        object-fit: cover;
    }

    .imagePlaceholder {
        position: absolute;
        height: 100%;
        width: 100%;
        top: 0%;
        right: 0%;
        bottom: 0%;
        left: 0%;
        overflow: hidden;
    }

    .pageTitle {
        align-self: stretch;
        position: relative;
        letter-spacing: -0.6px;
        line-height: 38px;
        font-weight: 600;
        font-size: inherit;
        margin: 0;
        color: #000;
    }

    .subtitle {
        margin: 0;
    }

    .atVeroEosContainer {
        align-self: stretch;
        position: relative;
        font-size: 12px;
        line-height: 20px;
        color: #3e3e59;
    }

    .text1 {
        align-self: stretch;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;
        gap: 12px;
    }

    .text {
        align-self: stretch;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }

    .content1 {
        position: absolute;
        width: calc(100% - 32px);
        top: calc(50% - 64px);
        right: 16px;
        left: 16px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }

    .content {
        align-self: stretch;
        flex: 1;
        position: relative;
    }

    .pageHeader {
        position: relative;
        background-color: #fff;
        width: 100%;
        height: 2820px;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;
        padding: 16px;
        box-sizing: border-box;
        text-align: center;
        font-size: 34px;
        color: #121212;
        font-family: Poppins;
    }
}
</style>